import type { FileIconProps } from './FileIcon';

function FileTextIcon({ color, size = 28, ...props }: FileIconProps) {
  return (
    <svg
      data-testid='icon-file-text'
      width={size}
      height={size * (36 / 28)}
      viewBox='0 0 28 36'
      fill='none'
      {...props}>
      <path
        d='M4 35H24C26.2091 35 28 33.2091 28 31V10L18 0H4C1.79086 0 0 1.79086 0 4V31C0 33.2091 1.79086 35 4 35Z'
        fill='#E3DFDC'
      />
      <path d='M18 10V0L28 10H18Z' fill='#F7F5F2' />
      <line
        x1='5.45996'
        y1='28.7042'
        x2='19.2808'
        y2='28.7042'
        stroke='#76706D'
        strokeWidth='1.5'
      />
      <line
        x1='5.45996'
        y1='24.8171'
        x2='19.2808'
        y2='24.8171'
        stroke='#76706D'
        strokeWidth='1.5'
      />
    </svg>
  );
}

export default FileTextIcon;
